import { Component, OnInit, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { UploadDocumentFormService } from '@camelot/files-extended';
import { FormComponent } from '@camelot/form-basic';
import { CamAbstractInput, IInputsError } from '@camelot/form-model';
import { CamEnumerationService, TranslatedEnumeration } from '@camelot/services';
import { CamBaseModal } from '@camelot/utils';

export interface UploadDocumentResult {
  description?: string;
  documentTypeId: number;
}

@Component({
  selector: 'cam-upload-document-content',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss'],
  imports: [FormComponent],
})
export class UploadDocumentModal extends CamBaseModal<null, UploadDocumentResult> implements OnInit {
  private _enumTypeService = inject(CamEnumerationService);
  private _form = inject(UploadDocumentFormService);

  public form: CamAbstractInput[] = [];
  public error: IInputsError = { status: 0, message: '' };

  public loader = false;

  get fileTypes$(): Observable<TranslatedEnumeration[]> {
    return this._enumTypeService.fetchFileTypes();
  }

  ngOnInit() {
    this.form = this._form.getGroupForm({
      description: '',
      documentTypes$: this.fileTypes$,
    });
  }

  public onSaveClick = (values: { description: string; documentType: string }): void => {
    const result: UploadDocumentResult = {
      description: values.description,
      documentTypeId: Number(values.documentType),
    };
    this.modalState()?.completed(result);
    this.closeEvent.emit(result);
  };
}
